import React from 'react';
import './RecipeCard.css';

const RecipeCard = ({name, image, price, time, servings}) => {
    return (
        <div className="recipe-card">
            <div className="recipe-image">
                <img
                    src={image}
                    alt={name}
                />
            </div>

            <div className="recipe-info">
                <h2>{name}</h2>
            </div>
        </div>
    );
};

export default RecipeCard;